import { IDiscoverDestination } from 'APP/model/tenantRouter/tenantRouterModel.types';

export interface IDiscoverDestinationWithoutKey extends Omit<IDiscoverDestination, 'key'> {
  key?: string;
}

export function getDiscoverDestinationKey(
  discoverDestination: IDiscoverDestinationWithoutKey
): string {
  const { type, alias, isLocal } = discoverDestination;
  return `${type}-${alias}${isLocal ? '-local' : ''}`;
}

export function createDiscoverDestinationWithKey(
  discoverDestination: IDiscoverDestinationWithoutKey
): IDiscoverDestination {
  return {
    ...discoverDestination,
    key: getDiscoverDestinationKey(discoverDestination),
  };
}
